export enum DashboardTabName {
  BorrowerInformation = 'Borrower Information',
  CoBorrowerInformation = 'CoBorrower Information',
  HomeOwnership = 'Homeownership',
  WorkOrder = 'Work Order',
  FundingInformation = 'Funding',
  AdditionalInformation = 'Additional Info',
  ContractorInfo = 'Contractor Info',
}
